import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import PercentageDataPod from '../../../components/PercentageDataPod';
import { ReactComponent as StarfishSvg } from './starfish.svg';

const messages = defineMessages({
  studentRetention: {
    id: 'hubs.studies.student-retention',
    defaultMessage: 'Student Retention',
  },
  description: {
    id: 'hubs.studies.student-retention.description',
    defaultMessage: 'Percentage of students who return their sophomore year',
  },
  tooltip: {
    id: 'hubs.studies.student-retention.tooltip',
    defaultMessage:
      'This school uses Starfish, a tool to help students reach their academic and career goals. Colleges and universities that use Starfish have invested in student success resources to track academic progress, connect with advisors and leverage student support services.',
  },
  tooltipHeader: {
    id: 'hubs.studies.student-retention.tooltip-header',
    defaultMessage: 'Great news!',
  },
});

const StudentRetention = ({
  studentRetentionValue,
  lastUpdated,
  isStarfishClient = true,
  origin,
  intl,
}) => {
  const tooltip = isStarfishClient && intl.formatMessage(messages.tooltip).split('\n');
  const value = Math.floor(studentRetentionValue);
  const title = intl.formatMessage(messages.studentRetention);

  return (
    studentRetentionValue > 0 && (
      <PercentageDataPod
        header={title}
        footer={lastUpdated}
        tooltip={tooltip}
        tooltipHeader={intl.formatMessage(messages.tooltipHeader)}
        ariaLabel={`${title}, ${value}%`}
        content={{
          values: [
            {
              label: '',
              value,
            },
          ],
          text: intl.formatMessage(messages.description),
        }}
        CustomTooltipIcon={StarfishSvg}
      />
    )
  );
};

StudentRetention.propTypes = {
  acceptanceRate: PropTypes.object,
  admissionsTab: PropTypes.bool,
  lastUpdated: PropTypes.string,
  isStarfishClient: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(StudentRetention);
